export const SALES_BOOK_LOADING = "SALES_BOOK_LOADING";
export const SALES_BOOK_RESET = "SALES_BOOK_RESET";
export const GET_SALES_BOOK = "GET_SALES_BOOK";
export const GET_SALES_BOOK_SUCCESS = "GET_SALES_BOOK_SUCCESS";
export const GET_SALES_BOOK_FAIL = "GET_SALES_BOOK_FAIL";
export const DELETE_SALES_BOOK = "DELETE_SALES_BOOK"
export const DELETE_SALES_BOOK_SUCCESS = "DELETE_SALES_BOOK_SUCCESS"
export const DELETE_SALES_BOOK_FAIL = "DELETE_SALES_BOOK_FAIL"
export const UPDATE_SALES_BOOK = "UPDATE_SALES_BOOK"
export const UPDATE_SALES_BOOK_SUCCESS = "UPDATE_SALES_BOOK_SUCCESS"
export const UPDATE_SALES_BOOK_FAIL = "UPDATE_SALES_BOOK_FAIL"
export const ADD_NEW_SALES_BOOK = "ADD_NEW_SALES_BOOK"
export const ADD_SALES_BOOK_SUCCESS = "ADD_SALES_BOOK_SUCCESS"
export const ADD_SALES_BOOK_FAIL = "ADD_SALES_BOOK_FAIL"